import React, { useEffect } from "react";
import CommonDropDown from "../../Common/DropDown/CommonDropDown";

export type DisplayValue = {
  value: string;
  display: string;
};

type Props = {
  displayValues: DisplayValue[];
  name: string;
  label: string;
  value: string;
  style: React.CSSProperties;
  onChange: (name: string, value: string) => void;
  disabled: boolean;
  unit: string;
  dropDownStyle?: React.CSSProperties;
};

export default function DefaultImagingSettingComboBox({
  displayValues,
  name,
  label,
  value,
  style,
  onChange,
  disabled,
  unit,
  dropDownStyle,
}: Props) {
  var dropDownDisplayValue = displayValues.map((displayValue) => {
    return {
      display: displayValue.display,
      value: displayValue.value,
      disabled: false,
    };
  });
  

  const labelView = unit.length > 0 ? `${label} (${unit})` : label;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "baseline",
        justifyContent: "flex-start",
        color: disabled ? "#808080" : "#000000",
        borderColor: disabled
          ? "rgba(118, 118, 118, 0.3)"
          : "rgba(118, 118, 118, 1)",
        ...style,
      }}
    >
      <div
        style={{
          width: 125,
          lineHeight: "16px",
          fontSize: "13px",
          textAlign: "left",
          margin: "auto 0px"
        }}
      >
        {labelView}
      </div>
      <CommonDropDown
        id={name}
        style={{
          width: "253px",
          height: "34px",
          color: disabled ? "#808080" : "#000000",
          backgroundColor: disabled ? "rgba(204, 204, 204, 0.1)" : "#FFFFFF",
          borderColor: disabled
            ? "rgba(133, 133, 133, 0.3)"
            : "rgb(133, 133, 133)",
          fontSize: 13.3,
          ...dropDownStyle
        }}
        disabled={disabled}
        onChange={(val) => onChange(name, val)}
        value={value}
        dropDownDisplayValues={dropDownDisplayValue}
      />
    </div>
  );
}
